import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrl, baseUrl } from "../../../utils/apis";

interface GetChatHistoryParams {
  case_id?: number;
  consultation_id?: number;
  page: number;
}


export const ChatHistroyApiFetching = createApi({
  reducerPath: "ChatHistoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem("token");

      headers.set("Content-Type", "application/json");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  tagTypes: ["chatHistory"],

  endpoints: (builder) => ({
    getChatHistory: builder.query<any, GetChatHistoryParams>({
      query: ({ case_id, consultation_id, page }) => {
        const params: Record<string, number> = { page };

        if (case_id) params.case_id = case_id;
        if (consultation_id) params.consultation_id = consultation_id;

        return {
          url: apiUrl.cahtHistoryApi,
          params,
        };
      },
      providesTags: ["chatHistory"],
    }),
  }),
});

export const { useLazyGetChatHistoryQuery } = ChatHistroyApiFetching;
